<template>
  <div class="page-report-detail"
       v-if="src.length !== 0"
  >
    <div class="img-block"
         v-for="(item, index) in src"
         :key="index"
    >
      <div class="page-index">第{{ index + 1 }}页/共{{ src.length }}页</div>
      <ym-img class="report-img"
              :src="item"
              alt="我的学习报告"
      />
      <div class="hint">长按保存图片</div>
    </div>
  </div>
</template>

<script>
  import { getReportDetail } from '@/services/report';

  export default {
    name: 'PageReportDetail',
    metaInfo: {
      title: '能力评估报告',
    },
    data() {
      return {
        src: [],
      };
    },
    methods: {
      async fetchData(id) {
        const data = await getReportDetail(id);
        this.src = data.src;
      },
    },
    created() {
      this.fetchData(this.$route.params.id);
    },
    beforeRouteUpdate(to, from, next) {
      this.fetchData(to.params.id);
      next();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-report-detail {
    min-height: 100%;
    padding: 0 @size-base;
    box-sizing: border-box;
    background: @color-white;
    &.audio {
      padding-top: @size-large + @size-base;
    }
  }

  .img-block {
    width: 690px;
    margin: 0 auto;
    padding: @size-medium 0 @size-large 0;
    img {
      width: 100%;
      display: block;
      box-shadow: 0 10px 10px @color-gray-lighter;
    }
    &:not(:last-child) {
      border-bottom: @border-base;
    }
  }

  .page-index {
    margin-bottom: @size-small;
    font-size: @font-size-base;
    color: @color-text-light;
    text-align: right;
  }

  .report-img {
    width: 690px;
    height: 975px;
  }

  .hint {
    margin-top: @size-small;
    font-size: @font-size-medium;
    text-align: center;
    color: @color-text-lighter;
  }

</style>
